export default __webpack_public_path__ + "static/media/_MG_8698.2a965a17.jpg";